import Organization from "./Organization";
import SbomProjectGroup from "./SbomProjectGroup";
import SbomProjectVersion from "./SbomProjectVersion";
import SoftwareLicensePolicy from "./SoftwareLicensePolicy";

class SbomProject {

    constructor(
        public id?: string,
        public name?: string,
        public organization?: Organization,
        public softwareLicensePolicy?: SoftwareLicensePolicy,
        public groupIds?: string[],
        public groups?: SbomProjectGroup[],
        public versions?: SbomProjectVersion[]) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) {
            return null;
        }

        const sbomProject = new SbomProject();

        sbomProject.id = data.id;
        sbomProject.name = data.name;
        sbomProject.organization = (data.organization) ? Organization.fromPOJO(data.organization) : undefined;
        sbomProject.softwareLicensePolicy = (data.softwareLicensePolicy) ? SoftwareLicensePolicy.fromPOJO(data.softwareLicensePolicy) : undefined;
        sbomProject.groups = (data.groups ?? [])
            .map(groupData => SbomProjectGroup.fromPOJO(groupData))
            .filter((group): group is SbomProjectGroup => group !== null);
        sbomProject.groupIds = sbomProject.groups
            .map(group => group.id)
            .filter((id): id is string => id !== undefined);
        sbomProject.versions = (data.versions)
            ? data.versions.map(versionData => SbomProjectVersion.fromPOJO(versionData))
            : undefined;

        return sbomProject;
    }

}

export default SbomProject;
